import React from 'react';
import { Control } from 'react-redux-form';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import 'react-datepicker/dist/react-datepicker.css';

// CSS Modules, react-datepicker-cssmodules.css
// import 'react-datepicker/dist/react-datepicker-cssmodules.css';

export default ({
  viewDateFormat = 'YYYY-MM-DD',
  modelDateFormat = 'YYYY-MM-DD',
  ...props
}) => (
  <Control.custom
    component={DatePicker}
    mapProps={{
      selected: ownProps =>
        ownProps.modelValue ? moment(ownProps.modelValue) : null,
      onChange: ownProps => value => {
        const m = moment(value);
        return ownProps.onChange(
          m.isValid() ? m.format(modelDateFormat) : null
        );
      },
      onBlur: ownProps => ownProps.onBlur,
      onFocus: ownProps => ownProps.onFocus,
    }}
    dateFormat={viewDateFormat}
    autoComplete="off"
    {...props}
  />
);



// WEBPACK FOOTER //
// ./src/components/common/Forms/DatePicker.jsx